var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C3.89474 10 3 10.8947 3 12C3 13.1053 3.89474 14 5 14C6.10526 14 7 13.1053 7 12C7 10.8947 6.10526 10 5 10ZM5 4C3.89474 4 3 4.89474 3 6C3 7.10526 3.89474 8 5 8C6.10526 8 7 7.10526 7 6C7 4.89474 6.10526 4 5 4ZM5 16C3.89474 16 3 16.8947 3 18C3 19.1053 3.89474 20 5 20C6.10526 20 7 19.1053 7 18C7 16.8947 6.10526 16 5 16ZM20 11H10C9.45614 11 9 11.4561 9 12C9 12.5439 9.45614 13 10 13H20C20.5439 13 21 12.5439 21 12C21 11.4561 20.5439 11 20 11ZM20 5H10C9.45614 5 9 5.45614 9 6C9 6.54386 9.45614 7 10 7H20C20.5439 7 21 6.54386 21 6C21 5.45614 20.5439 5 20 5ZM20 17H10C9.45614 17 9 17.4561 9 18C9 18.5439 9.45614 19 10 19H20C20.5439 19 21 18.5439 21 18C21 17.4561 20.5439 17 20 17Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.72571f6f.svg";
export { ForwardRef as ReactComponent };